// RTK Query throws synchronously from refetch() when the hook's query is not running:
// the component unmounted (e.g. the user switched tab or pressed Next while a save was
// in flight) or the query is skipped. Production builds minify the message to error #38.
const isQueryNotStartedError = (error: unknown) =>
  error instanceof Error &&
  (error.message.includes('has not been started') || error.message.includes('Redux Toolkit error #38'));

/**
 * Refresh query data after a successful save. The save has already succeeded at this
 * point, and an unmounted component refetches on its next mount, so the "not started"
 * case must not be reported to the user as a failed save.
 */
export const refetchAfterSave = (refetch?: (() => unknown) | null) => {
  if (!refetch) return;
  try {
    refetch();
  } catch (error) {
    if (isQueryNotStartedError(error)) return;
    throw error;
  }
};
